// extracted by mini-css-extract-plugin
export default {"sidebar":"styles_sidebar__5jBK6","sidebarLinks":"styles_sidebarLinks__9hB7s","webLink":"styles_webLink__scFG5","active":"styles_active__A0rCQ","logout":"styles_logout__sGta1"};